import { computed } from 'vue'
import { useOrgStore } from '@/stores/org'

export function useOrgMembership() {
  const orgStore = useOrgStore()
  const selectedOrg = computed(() => orgStore.getSelectedOrg)

  const isOrgMember = computed(() => selectedOrg.value?.is_member ?? false)
  const orgName = computed(() => selectedOrg.value?.organization_name ?? '')

  return { isOrgMember, orgName, selectedOrg }
}
